export default __webpack_public_path__ + "27cba938e4293cb9fa02a63626e7139f.jpg";